/* tslint:disable */
/* eslint-disable */
/**
 * grpc/v1/deals_service.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common'
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from '../base'
// @ts-ignore
import type { RequestArgs } from '../base'
// @ts-ignore
import { DealsServiceAddDealFileBody } from '../models'
// @ts-ignore
import { DealsServiceAddDealSupportManagerBody } from '../models'
// @ts-ignore
import { DealsServiceChangeStageBody } from '../models'
// @ts-ignore
import { DealsServiceCheckStageTransitionBody } from '../models'
// @ts-ignore
import { DealsServiceCreateDealCommentBody } from '../models'
// @ts-ignore
import { DealsServiceCreateTaskBody } from '../models'
// @ts-ignore
import { DealsServiceUpdateDealBody } from '../models'
// @ts-ignore
import { DealsServiceUpdateDealCommentBody } from '../models'
// @ts-ignore
import { DealsServiceUpdateDealFileBody } from '../models'
// @ts-ignore
import { DealsServiceUpdateTaskBody } from '../models'
// @ts-ignore
import { RpcStatus } from '../models'
// @ts-ignore
import { V1AddDealFileResponse } from '../models'
// @ts-ignore
import { V1ChangeStageResponse } from '../models'
// @ts-ignore
import { V1CheckStageTransitionResponse } from '../models'
// @ts-ignore
import { V1CreateDealCommentResponse } from '../models'
// @ts-ignore
import { V1CreateDealRequest } from '../models'
// @ts-ignore
import { V1CreateDealResponse } from '../models'
// @ts-ignore
import { V1CreateTaskResponse } from '../models'
// @ts-ignore
import { V1DashboardMetricsResponse } from '../models'
// @ts-ignore
import { V1DealSupportManagersResponse } from '../models'
// @ts-ignore
import { V1GetDealActionLogsResponse } from '../models'
// @ts-ignore
import { V1GetDealResponse } from '../models'
// @ts-ignore
import { V1GetManagerAnalyticsResponse } from '../models'
// @ts-ignore
import { V1ListDealCommentsResponse } from '../models'
// @ts-ignore
import { V1ListDealFilesResponse } from '../models'
// @ts-ignore
import { V1ListDealManagersResponse } from '../models'
// @ts-ignore
import { V1ListDealsResponse } from '../models'
// @ts-ignore
import { V1ListTaskEditsResponse } from '../models'
// @ts-ignore
import { V1ListTasksResponse } from '../models'
// @ts-ignore
import { V1UpdateDealCommentResponse } from '../models'
// @ts-ignore
import { V1UpdateDealFileResponse } from '../models'
// @ts-ignore
import { V1UpdateDealResponse } from '../models'
// @ts-ignore
import { V1UpdateTaskResponse } from '../models'
/**
 * DealsServiceApi - axios parameter creator
 * @export
 */
export const DealsServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary -------------------- Files --------------------
     * @param {string} dealId
     * @param {DealsServiceAddDealFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceAddDealFile: async (
      dealId: string,
      body: DealsServiceAddDealFileBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceAddDealFile', 'dealId', dealId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('dealsServiceAddDealFile', 'body', body)
      const localVarPath = `/api/v1/deals/{dealId}/files`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary -------------------- Deal Support Managers (DEV-699) -------------------- AddDealSupportManager — подключить сопровождающего менеджера к сделке. Доступ: ответственный по сделке / hos / admin (гейт в service-слое). Подключаемый пользователь обязан иметь роль support_manager (проверка через auth, fail-close). Сопровождающий ≠ ответственный; сделка должна быть активной; повторное подключение активного сопровождающего — идемпотентный no-op. Возвращает актуальный список АКТИВНЫХ сопровождающих после операции.
     * @param {string} dealId
     * @param {DealsServiceAddDealSupportManagerBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceAddDealSupportManager: async (
      dealId: string,
      body: DealsServiceAddDealSupportManagerBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceAddDealSupportManager', 'dealId', dealId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('dealsServiceAddDealSupportManager', 'body', body)
      const localVarPath = `/api/v1/deals/{dealId}/support-managers`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary -------------------- Stages (упрощенные) --------------------
     * @param {string} dealId
     * @param {DealsServiceChangeStageBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceChangeStage: async (
      dealId: string,
      body: DealsServiceChangeStageBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceChangeStage', 'dealId', dealId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('dealsServiceChangeStage', 'body', body)
      const localVarPath = `/api/v1/deals/{dealId}/stage`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary CheckStageTransition — DEV-527. Precheck перехода на этап (без мутаций): блокирующие обязательные задачи + мягкий WIP-лимит. Гейт = deals:read.
     * @param {string} dealId
     * @param {DealsServiceCheckStageTransitionBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceCheckStageTransition: async (
      dealId: string,
      body: DealsServiceCheckStageTransitionBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceCheckStageTransition', 'dealId', dealId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('dealsServiceCheckStageTransition', 'body', body)
      const localVarPath = `/api/v1/deals/{dealId}/stage:check`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary -------------------- Deals --------------------
     * @param {V1CreateDealRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceCreateDeal: async (
      body: V1CreateDealRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('dealsServiceCreateDeal', 'body', body)
      const localVarPath = `/api/v1/deals`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} dealId
     * @param {DealsServiceCreateDealCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceCreateDealComment: async (
      dealId: string,
      body: DealsServiceCreateDealCommentBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceCreateDealComment', 'dealId', dealId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('dealsServiceCreateDealComment', 'body', body)
      const localVarPath = `/api/v1/deals/{dealId}/comments`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary -------------------- Tasks --------------------
     * @param {string} dealId
     * @param {DealsServiceCreateTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceCreateTask: async (
      dealId: string,
      body: DealsServiceCreateTaskBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceCreateTask', 'dealId', dealId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('dealsServiceCreateTask', 'body', body)
      const localVarPath = `/api/v1/deals/{dealId}/tasks`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id UUID сделки - обязательно
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceDeleteDeal: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('dealsServiceDeleteDeal', 'id', id)
      const localVarPath = `/api/v1/deals/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} dealId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceDeleteDealComment: async (
      dealId: string,
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceDeleteDealComment', 'dealId', dealId)
      // verify required parameter 'id' is not null or undefined
      assertParamExists('dealsServiceDeleteDealComment', 'id', id)
      const localVarPath = `/api/v1/deals/{dealId}/comments/{id}`
        .replace(`{${'dealId'}}`, encodeURIComponent(String(dealId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} dealId
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceDeleteDealFile: async (
      dealId: string,
      fileId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceDeleteDealFile', 'dealId', dealId)
      // verify required parameter 'fileId' is not null or undefined
      assertParamExists('dealsServiceDeleteDealFile', 'fileId', fileId)
      const localVarPath = `/api/v1/deals/{dealId}/files/{fileId}`
        .replace(`{${'dealId'}}`, encodeURIComponent(String(dealId)))
        .replace(`{${'fileId'}}`, encodeURIComponent(String(fileId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} dealId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceDeleteTask: async (
      dealId: string,
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceDeleteTask', 'dealId', dealId)
      // verify required parameter 'id' is not null or undefined
      assertParamExists('dealsServiceDeleteTask', 'id', id)
      const localVarPath = `/api/v1/deals/{dealId}/tasks/{id}`
        .replace(`{${'dealId'}}`, encodeURIComponent(String(dealId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} [period] Период для расчёта прироста (опционально, по умолчанию - week)  \&quot;day\&quot;, \&quot;week\&quot;, \&quot;month\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceGetDashboardMetrics: async (
      period?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/deals/dashboard-metrics`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (period !== undefined) {
        localVarQueryParameter['period'] = period
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id UUID сделки - обязательно
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceGetDeal: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('dealsServiceGetDeal', 'id', id)
      const localVarPath = `/api/v1/deals/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary -------------------- Action Logs --------------------
     * @param {string} dealId UUID сделки - обязательно
     * @param {number} [paginationPageSize] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [paginationPageToken] Курсор из next_page_token предыдущего ответа; \&quot;\&quot; &#x3D; первая страница.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceGetDealActionLogs: async (
      dealId: string,
      paginationPageSize?: number,
      paginationPageToken?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceGetDealActionLogs', 'dealId', dealId)
      const localVarPath = `/api/v1/deals/{dealId}/logs`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPageSize !== undefined) {
        localVarQueryParameter['pagination.pageSize'] = paginationPageSize
      }

      if (paginationPageToken !== undefined) {
        localVarQueryParameter['pagination.pageToken'] = paginationPageToken
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetManagerAnalytics — агрегированная аналитика работы менеджеров: участие в сделках по этапам, исходы Won/Lost при участии, задачи выполнено/просрочено. Только для ролей hos/admin (проверка в service-слое).
     * @param {string} [periodFrom] Период: пересечение интервала ответственности менеджера с [period_from, period_to). Обе границы опциональны (нет границы &#x3D; без ограничения).
     * @param {string} [periodTo]
     * @param {Array<string>} [managerIds] Фильтр по менеджерам; пусто &#x3D; все менеджеры.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceGetManagerAnalytics: async (
      periodFrom?: string,
      periodTo?: string,
      managerIds?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/deals/manager-analytics`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodFrom !== undefined) {
        localVarQueryParameter['periodFrom'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['periodTo'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      if (managerIds) {
        localVarQueryParameter['managerIds'] = managerIds
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} clientId
     * @param {number} [paginationPageSize] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [paginationPageToken] Курсор из next_page_token предыдущего ответа; \&quot;\&quot; &#x3D; первая страница.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceListClientDeals: async (
      clientId: string,
      paginationPageSize?: number,
      paginationPageToken?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'clientId' is not null or undefined
      assertParamExists('dealsServiceListClientDeals', 'clientId', clientId)
      const localVarPath = `/api/v1/deals/client/{clientId}`.replace(
        `{${'clientId'}}`,
        encodeURIComponent(String(clientId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPageSize !== undefined) {
        localVarQueryParameter['pagination.pageSize'] = paginationPageSize
      }

      if (paginationPageToken !== undefined) {
        localVarQueryParameter['pagination.pageToken'] = paginationPageToken
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary -------------------- Comments (DEV-195) -------------------- Список комментариев менеджера по сделке. Возвращаются в хронологическом порядке (от старого к новому). ФИО автора резолвится фронтом по локальному списку менеджеров — backend отдаёт только manager_id.
     * @param {string} dealId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceListDealComments: async (
      dealId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceListDealComments', 'dealId', dealId)
      const localVarPath = `/api/v1/deals/{dealId}/comments`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} dealId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceListDealFiles: async (
      dealId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceListDealFiles', 'dealId', dealId)
      const localVarPath = `/api/v1/deals/{dealId}/files`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary -------------------- Deal Managers (DEV-197) -------------------- ListDealManagers — история ответственных менеджеров сделки с диапазонами этапов. Только для ролей hos/admin (проверка в service-слое) — данные используются для KPI/вознаграждения.
     * @param {string} dealId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceListDealManagers: async (
      dealId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceListDealManagers', 'dealId', dealId)
      const localVarPath = `/api/v1/deals/{dealId}/managers`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {number} [paginationPageSize] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [paginationPageToken] Курсор из next_page_token предыдущего ответа; \&quot;\&quot; &#x3D; первая страница.
     * @param {Array<DealsServiceListDealsStageTypesEnum>} [stageTypes] DEV-206. Серверные фильтры — раньше канбан брал топ-50 по created_at DESC и фильтровал на клиенте, из-за чего «хвостовые» сделки терялись.   - STAGE_TYPE_INVALID: Невалидный тип  - STAGE_TYPE_UNSORTED: Не разобрано (скрытый этап для РОП)  - STAGE_TYPE_NEW_LEAD: Новый ЛИД  - STAGE_TYPE_NO_CONTACT: Не вышел на связь  - STAGE_TYPE_CONTACTED: Вышел на связь  - STAGE_TYPE_QUALIFIED: Квалифицирован  - STAGE_TYPE_OFFER_SENT: Предложение отправлено  - STAGE_TYPE_PRESENTATION_SCHEDULED: Презентация назначена  - STAGE_TYPE_PRESENTATION_DONE: Презентация проектов проведена  - STAGE_TYPE_FOLLOWUP_PRESENTATION_DONE: Повторная встреча / презентация проведена  - STAGE_TYPE_BOOKED: Объект забронирован  - STAGE_TYPE_DEPOSIT_PAID: Депозит внесен  - STAGE_TYPE_CONTRACT_SIGNED: Договор бронирования подписан / внесен DP  - STAGE_TYPE_CONTRACT_HANDED_OVER: Оригинал договора передан застройщику  - STAGE_TYPE_COMMISSION_PAID: Комиссионные выплачены  - STAGE_TYPE_LOST: Закрыто и не реализовано
     * @param {DealsServiceListDealsStatusEnum} [status]  - DEAL_STATUS_INVALID: Невалидный статус  - DEAL_STATUS_ACTIVE: Сделка активна  - DEAL_STATUS_WON: Сделка успешно закрыта  - DEAL_STATUS_LOST: Сделка закрыта без положительного результата  - DEAL_STATUS_CANCELED: Сделка отменена
     * @param {string} [responsibleManagerId]
     * @param {string} [clientId]
     * @param {string} [search] FTS по title + body deal_comments (&#x60;to_tsvector&#x60; / &#x60;plainto_tsquery&#x60;). DEV-195: после выноса комментариев в 1:N поиск идёт по title сделки и EXISTS-подзапросу по deal_comments.body. Поиск по имени клиента/менеджера тут НЕ делается — это другой сервис; фронт сначала резолвит клиента в client_id.
     * @param {string} [createdAfter]
     * @param {string} [createdBefore]
     * @param {string} [agentId] DEV-512. Фильтр по агенту (deals.agent_id, снапшот DEV-474) — для вкладки «Сделки» в карточке агента. \&quot;\&quot; игнорируется.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceListDeals: async (
      paginationPageSize?: number,
      paginationPageToken?: string,
      stageTypes?: Array<DealsServiceListDealsStageTypesEnum>,
      status?: DealsServiceListDealsStatusEnum,
      responsibleManagerId?: string,
      clientId?: string,
      search?: string,
      createdAfter?: string,
      createdBefore?: string,
      agentId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/deals`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (paginationPageSize !== undefined) {
        localVarQueryParameter['pagination.pageSize'] = paginationPageSize
      }

      if (paginationPageToken !== undefined) {
        localVarQueryParameter['pagination.pageToken'] = paginationPageToken
      }

      if (stageTypes) {
        localVarQueryParameter['stageTypes'] = stageTypes
      }

      if (status !== undefined) {
        localVarQueryParameter['status'] = status
      }

      if (responsibleManagerId !== undefined) {
        localVarQueryParameter['responsibleManagerId'] = responsibleManagerId
      }

      if (clientId !== undefined) {
        localVarQueryParameter['clientId'] = clientId
      }

      if (search !== undefined) {
        localVarQueryParameter['search'] = search
      }

      if (createdAfter !== undefined) {
        localVarQueryParameter['createdAfter'] =
          (createdAfter as any) instanceof Date ? (createdAfter as any).toISOString() : createdAfter
      }

      if (createdBefore !== undefined) {
        localVarQueryParameter['createdBefore'] =
          (createdBefore as any) instanceof Date
            ? (createdBefore as any).toISOString()
            : createdBefore
      }

      if (agentId !== undefined) {
        localVarQueryParameter['agentId'] = agentId
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary DEV-196. История редактирований задач сделки (кто и когда правил описание/сроки). Возвращается от новых к старым. ФИО редактора резолвит фронт по списку менеджеров.
     * @param {string} dealId
     * @param {string} [taskId] Фильтр по задаче (опционально)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceListTaskEdits: async (
      dealId: string,
      taskId?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceListTaskEdits', 'dealId', dealId)
      const localVarPath = `/api/v1/deals/{dealId}/task-edits`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (taskId !== undefined) {
        localVarQueryParameter['taskId'] = taskId
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} dealId
     * @param {DealsServiceListTasksStageTypeEnum} [stageType] Фильтр по этапу (опционально)   - STAGE_TYPE_INVALID: Невалидный тип  - STAGE_TYPE_UNSORTED: Не разобрано (скрытый этап для РОП)  - STAGE_TYPE_NEW_LEAD: Новый ЛИД  - STAGE_TYPE_NO_CONTACT: Не вышел на связь  - STAGE_TYPE_CONTACTED: Вышел на связь  - STAGE_TYPE_QUALIFIED: Квалифицирован  - STAGE_TYPE_OFFER_SENT: Предложение отправлено  - STAGE_TYPE_PRESENTATION_SCHEDULED: Презентация назначена  - STAGE_TYPE_PRESENTATION_DONE: Презентация проектов проведена  - STAGE_TYPE_FOLLOWUP_PRESENTATION_DONE: Повторная встреча / презентация проведена  - STAGE_TYPE_BOOKED: Объект забронирован  - STAGE_TYPE_DEPOSIT_PAID: Депозит внесен  - STAGE_TYPE_CONTRACT_SIGNED: Договор бронирования подписан / внесен DP  - STAGE_TYPE_CONTRACT_HANDED_OVER: Оригинал договора передан застройщику  - STAGE_TYPE_COMMISSION_PAID: Комиссионные выплачены  - STAGE_TYPE_LOST: Закрыто и не реализовано
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceListTasks: async (
      dealId: string,
      stageType?: DealsServiceListTasksStageTypeEnum,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceListTasks', 'dealId', dealId)
      const localVarPath = `/api/v1/deals/{dealId}/tasks`.replace(
        `{${'dealId'}}`,
        encodeURIComponent(String(dealId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (stageType !== undefined) {
        localVarQueryParameter['stageType'] = stageType
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary RemoveDealSupportManager — снять сопровождающего менеджера со сделки (soft: removed_at/removed_by). Гейт тот же, что у Add. Снятие неактивного — идемпотентный no-op. Возвращает актуальный список активных сопровождающих.
     * @param {string} dealId
     * @param {string} managerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceRemoveDealSupportManager: async (
      dealId: string,
      managerId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceRemoveDealSupportManager', 'dealId', dealId)
      // verify required parameter 'managerId' is not null or undefined
      assertParamExists('dealsServiceRemoveDealSupportManager', 'managerId', managerId)
      const localVarPath = `/api/v1/deals/{dealId}/support-managers/{managerId}`
        .replace(`{${'dealId'}}`, encodeURIComponent(String(dealId)))
        .replace(`{${'managerId'}}`, encodeURIComponent(String(managerId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id UUID сделки - обязательно
     * @param {DealsServiceUpdateDealBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceUpdateDeal: async (
      id: string,
      body: DealsServiceUpdateDealBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('dealsServiceUpdateDeal', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('dealsServiceUpdateDeal', 'body', body)
      const localVarPath = `/api/v1/deals/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} dealId
     * @param {string} id
     * @param {DealsServiceUpdateDealCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceUpdateDealComment: async (
      dealId: string,
      id: string,
      body: DealsServiceUpdateDealCommentBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceUpdateDealComment', 'dealId', dealId)
      // verify required parameter 'id' is not null or undefined
      assertParamExists('dealsServiceUpdateDealComment', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('dealsServiceUpdateDealComment', 'body', body)
      const localVarPath = `/api/v1/deals/{dealId}/comments/{id}`
        .replace(`{${'dealId'}}`, encodeURIComponent(String(dealId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} dealId
     * @param {string} fileId
     * @param {DealsServiceUpdateDealFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceUpdateDealFile: async (
      dealId: string,
      fileId: string,
      body: DealsServiceUpdateDealFileBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceUpdateDealFile', 'dealId', dealId)
      // verify required parameter 'fileId' is not null or undefined
      assertParamExists('dealsServiceUpdateDealFile', 'fileId', fileId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('dealsServiceUpdateDealFile', 'body', body)
      const localVarPath = `/api/v1/deals/{dealId}/files/{fileId}`
        .replace(`{${'dealId'}}`, encodeURIComponent(String(dealId)))
        .replace(`{${'fileId'}}`, encodeURIComponent(String(fileId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} dealId
     * @param {string} id
     * @param {DealsServiceUpdateTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceUpdateTask: async (
      dealId: string,
      id: string,
      body: DealsServiceUpdateTaskBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'dealId' is not null or undefined
      assertParamExists('dealsServiceUpdateTask', 'dealId', dealId)
      // verify required parameter 'id' is not null or undefined
      assertParamExists('dealsServiceUpdateTask', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('dealsServiceUpdateTask', 'body', body)
      const localVarPath = `/api/v1/deals/{dealId}/tasks/{id}`
        .replace(`{${'dealId'}}`, encodeURIComponent(String(dealId)))
        .replace(`{${'id'}}`, encodeURIComponent(String(id)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * DealsServiceApi - functional programming interface
 * @export
 */
export const DealsServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = DealsServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary -------------------- Files --------------------
     * @param {string} dealId
     * @param {DealsServiceAddDealFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceAddDealFile(
      dealId: string,
      body: DealsServiceAddDealFileBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1AddDealFileResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceAddDealFile(
        dealId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceAddDealFile']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary -------------------- Deal Support Managers (DEV-699) -------------------- AddDealSupportManager — подключить сопровождающего менеджера к сделке. Доступ: ответственный по сделке / hos / admin (гейт в service-слое). Подключаемый пользователь обязан иметь роль support_manager (проверка через auth, fail-close). Сопровождающий ≠ ответственный; сделка должна быть активной; повторное подключение активного сопровождающего — идемпотентный no-op. Возвращает актуальный список АКТИВНЫХ сопровождающих после операции.
     * @param {string} dealId
     * @param {DealsServiceAddDealSupportManagerBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceAddDealSupportManager(
      dealId: string,
      body: DealsServiceAddDealSupportManagerBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1DealSupportManagersResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceAddDealSupportManager(
        dealId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceAddDealSupportManager']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary -------------------- Stages (упрощенные) --------------------
     * @param {string} dealId
     * @param {DealsServiceChangeStageBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceChangeStage(
      dealId: string,
      body: DealsServiceChangeStageBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ChangeStageResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceChangeStage(
        dealId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceChangeStage']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary CheckStageTransition — DEV-527. Precheck перехода на этап (без мутаций): блокирующие обязательные задачи + мягкий WIP-лимит. Гейт = deals:read.
     * @param {string} dealId
     * @param {DealsServiceCheckStageTransitionBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceCheckStageTransition(
      dealId: string,
      body: DealsServiceCheckStageTransitionBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CheckStageTransitionResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceCheckStageTransition(
        dealId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceCheckStageTransition']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary -------------------- Deals --------------------
     * @param {V1CreateDealRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceCreateDeal(
      body: V1CreateDealRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateDealResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceCreateDeal(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceCreateDeal']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} dealId
     * @param {DealsServiceCreateDealCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceCreateDealComment(
      dealId: string,
      body: DealsServiceCreateDealCommentBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateDealCommentResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceCreateDealComment(
        dealId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceCreateDealComment']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary -------------------- Tasks --------------------
     * @param {string} dealId
     * @param {DealsServiceCreateTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceCreateTask(
      dealId: string,
      body: DealsServiceCreateTaskBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1CreateTaskResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceCreateTask(
        dealId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceCreateTask']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id UUID сделки - обязательно
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceDeleteDeal(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceDeleteDeal(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceDeleteDeal']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} dealId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceDeleteDealComment(
      dealId: string,
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceDeleteDealComment(
        dealId,
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceDeleteDealComment']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} dealId
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceDeleteDealFile(
      dealId: string,
      fileId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceDeleteDealFile(
        dealId,
        fileId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceDeleteDealFile']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} dealId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceDeleteTask(
      dealId: string,
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceDeleteTask(
        dealId,
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceDeleteTask']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} [period] Период для расчёта прироста (опционально, по умолчанию - week)  \&quot;day\&quot;, \&quot;week\&quot;, \&quot;month\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceGetDashboardMetrics(
      period?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1DashboardMetricsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceGetDashboardMetrics(
        period,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceGetDashboardMetrics']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id UUID сделки - обязательно
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceGetDeal(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetDealResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceGetDeal(id, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceGetDeal']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary -------------------- Action Logs --------------------
     * @param {string} dealId UUID сделки - обязательно
     * @param {number} [paginationPageSize] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [paginationPageToken] Курсор из next_page_token предыдущего ответа; \&quot;\&quot; &#x3D; первая страница.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceGetDealActionLogs(
      dealId: string,
      paginationPageSize?: number,
      paginationPageToken?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetDealActionLogsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceGetDealActionLogs(
        dealId,
        paginationPageSize,
        paginationPageToken,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceGetDealActionLogs']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetManagerAnalytics — агрегированная аналитика работы менеджеров: участие в сделках по этапам, исходы Won/Lost при участии, задачи выполнено/просрочено. Только для ролей hos/admin (проверка в service-слое).
     * @param {string} [periodFrom] Период: пересечение интервала ответственности менеджера с [period_from, period_to). Обе границы опциональны (нет границы &#x3D; без ограничения).
     * @param {string} [periodTo]
     * @param {Array<string>} [managerIds] Фильтр по менеджерам; пусто &#x3D; все менеджеры.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceGetManagerAnalytics(
      periodFrom?: string,
      periodTo?: string,
      managerIds?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetManagerAnalyticsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceGetManagerAnalytics(
        periodFrom,
        periodTo,
        managerIds,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceGetManagerAnalytics']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} clientId
     * @param {number} [paginationPageSize] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [paginationPageToken] Курсор из next_page_token предыдущего ответа; \&quot;\&quot; &#x3D; первая страница.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceListClientDeals(
      clientId: string,
      paginationPageSize?: number,
      paginationPageToken?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListDealsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceListClientDeals(
        clientId,
        paginationPageSize,
        paginationPageToken,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceListClientDeals']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary -------------------- Comments (DEV-195) -------------------- Список комментариев менеджера по сделке. Возвращаются в хронологическом порядке (от старого к новому). ФИО автора резолвится фронтом по локальному списку менеджеров — backend отдаёт только manager_id.
     * @param {string} dealId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceListDealComments(
      dealId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListDealCommentsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceListDealComments(
        dealId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceListDealComments']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} dealId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceListDealFiles(
      dealId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListDealFilesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceListDealFiles(
        dealId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceListDealFiles']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary -------------------- Deal Managers (DEV-197) -------------------- ListDealManagers — история ответственных менеджеров сделки с диапазонами этапов. Только для ролей hos/admin (проверка в service-слое) — данные используются для KPI/вознаграждения.
     * @param {string} dealId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceListDealManagers(
      dealId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListDealManagersResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceListDealManagers(
        dealId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceListDealManagers']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {number} [paginationPageSize] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [paginationPageToken] Курсор из next_page_token предыдущего ответа; \&quot;\&quot; &#x3D; первая страница.
     * @param {Array<DealsServiceListDealsStageTypesEnum>} [stageTypes] DEV-206. Серверные фильтры — раньше канбан брал топ-50 по created_at DESC и фильтровал на клиенте, из-за чего «хвостовые» сделки терялись.   - STAGE_TYPE_INVALID: Невалидный тип  - STAGE_TYPE_UNSORTED: Не разобрано (скрытый этап для РОП)  - STAGE_TYPE_NEW_LEAD: Новый ЛИД  - STAGE_TYPE_NO_CONTACT: Не вышел на связь  - STAGE_TYPE_CONTACTED: Вышел на связь  - STAGE_TYPE_QUALIFIED: Квалифицирован  - STAGE_TYPE_OFFER_SENT: Предложение отправлено  - STAGE_TYPE_PRESENTATION_SCHEDULED: Презентация назначена  - STAGE_TYPE_PRESENTATION_DONE: Презентация проектов проведена  - STAGE_TYPE_FOLLOWUP_PRESENTATION_DONE: Повторная встреча / презентация проведена  - STAGE_TYPE_BOOKED: Объект забронирован  - STAGE_TYPE_DEPOSIT_PAID: Депозит внесен  - STAGE_TYPE_CONTRACT_SIGNED: Договор бронирования подписан / внесен DP  - STAGE_TYPE_CONTRACT_HANDED_OVER: Оригинал договора передан застройщику  - STAGE_TYPE_COMMISSION_PAID: Комиссионные выплачены  - STAGE_TYPE_LOST: Закрыто и не реализовано
     * @param {DealsServiceListDealsStatusEnum} [status]  - DEAL_STATUS_INVALID: Невалидный статус  - DEAL_STATUS_ACTIVE: Сделка активна  - DEAL_STATUS_WON: Сделка успешно закрыта  - DEAL_STATUS_LOST: Сделка закрыта без положительного результата  - DEAL_STATUS_CANCELED: Сделка отменена
     * @param {string} [responsibleManagerId]
     * @param {string} [clientId]
     * @param {string} [search] FTS по title + body deal_comments (&#x60;to_tsvector&#x60; / &#x60;plainto_tsquery&#x60;). DEV-195: после выноса комментариев в 1:N поиск идёт по title сделки и EXISTS-подзапросу по deal_comments.body. Поиск по имени клиента/менеджера тут НЕ делается — это другой сервис; фронт сначала резолвит клиента в client_id.
     * @param {string} [createdAfter]
     * @param {string} [createdBefore]
     * @param {string} [agentId] DEV-512. Фильтр по агенту (deals.agent_id, снапшот DEV-474) — для вкладки «Сделки» в карточке агента. \&quot;\&quot; игнорируется.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceListDeals(
      paginationPageSize?: number,
      paginationPageToken?: string,
      stageTypes?: Array<DealsServiceListDealsStageTypesEnum>,
      status?: DealsServiceListDealsStatusEnum,
      responsibleManagerId?: string,
      clientId?: string,
      search?: string,
      createdAfter?: string,
      createdBefore?: string,
      agentId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListDealsResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceListDeals(
        paginationPageSize,
        paginationPageToken,
        stageTypes,
        status,
        responsibleManagerId,
        clientId,
        search,
        createdAfter,
        createdBefore,
        agentId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceListDeals']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary DEV-196. История редактирований задач сделки (кто и когда правил описание/сроки). Возвращается от новых к старым. ФИО редактора резолвит фронт по списку менеджеров.
     * @param {string} dealId
     * @param {string} [taskId] Фильтр по задаче (опционально)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceListTaskEdits(
      dealId: string,
      taskId?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListTaskEditsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceListTaskEdits(
        dealId,
        taskId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceListTaskEdits']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} dealId
     * @param {DealsServiceListTasksStageTypeEnum} [stageType] Фильтр по этапу (опционально)   - STAGE_TYPE_INVALID: Невалидный тип  - STAGE_TYPE_UNSORTED: Не разобрано (скрытый этап для РОП)  - STAGE_TYPE_NEW_LEAD: Новый ЛИД  - STAGE_TYPE_NO_CONTACT: Не вышел на связь  - STAGE_TYPE_CONTACTED: Вышел на связь  - STAGE_TYPE_QUALIFIED: Квалифицирован  - STAGE_TYPE_OFFER_SENT: Предложение отправлено  - STAGE_TYPE_PRESENTATION_SCHEDULED: Презентация назначена  - STAGE_TYPE_PRESENTATION_DONE: Презентация проектов проведена  - STAGE_TYPE_FOLLOWUP_PRESENTATION_DONE: Повторная встреча / презентация проведена  - STAGE_TYPE_BOOKED: Объект забронирован  - STAGE_TYPE_DEPOSIT_PAID: Депозит внесен  - STAGE_TYPE_CONTRACT_SIGNED: Договор бронирования подписан / внесен DP  - STAGE_TYPE_CONTRACT_HANDED_OVER: Оригинал договора передан застройщику  - STAGE_TYPE_COMMISSION_PAID: Комиссионные выплачены  - STAGE_TYPE_LOST: Закрыто и не реализовано
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceListTasks(
      dealId: string,
      stageType?: DealsServiceListTasksStageTypeEnum,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1ListTasksResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceListTasks(
        dealId,
        stageType,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceListTasks']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary RemoveDealSupportManager — снять сопровождающего менеджера со сделки (soft: removed_at/removed_by). Гейт тот же, что у Add. Снятие неактивного — идемпотентный no-op. Возвращает актуальный список активных сопровождающих.
     * @param {string} dealId
     * @param {string} managerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceRemoveDealSupportManager(
      dealId: string,
      managerId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1DealSupportManagersResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.dealsServiceRemoveDealSupportManager(
          dealId,
          managerId,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceRemoveDealSupportManager']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id UUID сделки - обязательно
     * @param {DealsServiceUpdateDealBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceUpdateDeal(
      id: string,
      body: DealsServiceUpdateDealBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateDealResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceUpdateDeal(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceUpdateDeal']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} dealId
     * @param {string} id
     * @param {DealsServiceUpdateDealCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceUpdateDealComment(
      dealId: string,
      id: string,
      body: DealsServiceUpdateDealCommentBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateDealCommentResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceUpdateDealComment(
        dealId,
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceUpdateDealComment']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} dealId
     * @param {string} fileId
     * @param {DealsServiceUpdateDealFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceUpdateDealFile(
      dealId: string,
      fileId: string,
      body: DealsServiceUpdateDealFileBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateDealFileResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceUpdateDealFile(
        dealId,
        fileId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceUpdateDealFile']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} dealId
     * @param {string} id
     * @param {DealsServiceUpdateTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async dealsServiceUpdateTask(
      dealId: string,
      id: string,
      body: DealsServiceUpdateTaskBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1UpdateTaskResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.dealsServiceUpdateTask(
        dealId,
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['DealsServiceApi.dealsServiceUpdateTask']?.[localVarOperationServerIndex]
          ?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * DealsServiceApi - factory interface
 * @export
 */
export const DealsServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = DealsServiceApiFp(configuration)
  return {
    /**
     *
     * @summary -------------------- Files --------------------
     * @param {string} dealId
     * @param {DealsServiceAddDealFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceAddDealFile(
      dealId: string,
      body: DealsServiceAddDealFileBody,
      options?: any,
    ): AxiosPromise<V1AddDealFileResponse> {
      return localVarFp
        .dealsServiceAddDealFile(dealId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary -------------------- Deal Support Managers (DEV-699) -------------------- AddDealSupportManager — подключить сопровождающего менеджера к сделке. Доступ: ответственный по сделке / hos / admin (гейт в service-слое). Подключаемый пользователь обязан иметь роль support_manager (проверка через auth, fail-close). Сопровождающий ≠ ответственный; сделка должна быть активной; повторное подключение активного сопровождающего — идемпотентный no-op. Возвращает актуальный список АКТИВНЫХ сопровождающих после операции.
     * @param {string} dealId
     * @param {DealsServiceAddDealSupportManagerBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceAddDealSupportManager(
      dealId: string,
      body: DealsServiceAddDealSupportManagerBody,
      options?: any,
    ): AxiosPromise<V1DealSupportManagersResponse> {
      return localVarFp
        .dealsServiceAddDealSupportManager(dealId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary -------------------- Stages (упрощенные) --------------------
     * @param {string} dealId
     * @param {DealsServiceChangeStageBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceChangeStage(
      dealId: string,
      body: DealsServiceChangeStageBody,
      options?: any,
    ): AxiosPromise<V1ChangeStageResponse> {
      return localVarFp
        .dealsServiceChangeStage(dealId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary CheckStageTransition — DEV-527. Precheck перехода на этап (без мутаций): блокирующие обязательные задачи + мягкий WIP-лимит. Гейт = deals:read.
     * @param {string} dealId
     * @param {DealsServiceCheckStageTransitionBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceCheckStageTransition(
      dealId: string,
      body: DealsServiceCheckStageTransitionBody,
      options?: any,
    ): AxiosPromise<V1CheckStageTransitionResponse> {
      return localVarFp
        .dealsServiceCheckStageTransition(dealId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary -------------------- Deals --------------------
     * @param {V1CreateDealRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceCreateDeal(
      body: V1CreateDealRequest,
      options?: any,
    ): AxiosPromise<V1CreateDealResponse> {
      return localVarFp
        .dealsServiceCreateDeal(body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} dealId
     * @param {DealsServiceCreateDealCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceCreateDealComment(
      dealId: string,
      body: DealsServiceCreateDealCommentBody,
      options?: any,
    ): AxiosPromise<V1CreateDealCommentResponse> {
      return localVarFp
        .dealsServiceCreateDealComment(dealId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary -------------------- Tasks --------------------
     * @param {string} dealId
     * @param {DealsServiceCreateTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceCreateTask(
      dealId: string,
      body: DealsServiceCreateTaskBody,
      options?: any,
    ): AxiosPromise<V1CreateTaskResponse> {
      return localVarFp
        .dealsServiceCreateTask(dealId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id UUID сделки - обязательно
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceDeleteDeal(id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .dealsServiceDeleteDeal(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} dealId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceDeleteDealComment(dealId: string, id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .dealsServiceDeleteDealComment(dealId, id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} dealId
     * @param {string} fileId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceDeleteDealFile(
      dealId: string,
      fileId: string,
      options?: any,
    ): AxiosPromise<object> {
      return localVarFp
        .dealsServiceDeleteDealFile(dealId, fileId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} dealId
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceDeleteTask(dealId: string, id: string, options?: any): AxiosPromise<object> {
      return localVarFp
        .dealsServiceDeleteTask(dealId, id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} [period] Период для расчёта прироста (опционально, по умолчанию - week)  \&quot;day\&quot;, \&quot;week\&quot;, \&quot;month\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceGetDashboardMetrics(
      period?: string,
      options?: any,
    ): AxiosPromise<V1DashboardMetricsResponse> {
      return localVarFp
        .dealsServiceGetDashboardMetrics(period, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id UUID сделки - обязательно
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceGetDeal(id: string, options?: any): AxiosPromise<V1GetDealResponse> {
      return localVarFp.dealsServiceGetDeal(id, options).then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary -------------------- Action Logs --------------------
     * @param {string} dealId UUID сделки - обязательно
     * @param {number} [paginationPageSize] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [paginationPageToken] Курсор из next_page_token предыдущего ответа; \&quot;\&quot; &#x3D; первая страница.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceGetDealActionLogs(
      dealId: string,
      paginationPageSize?: number,
      paginationPageToken?: string,
      options?: any,
    ): AxiosPromise<V1GetDealActionLogsResponse> {
      return localVarFp
        .dealsServiceGetDealActionLogs(dealId, paginationPageSize, paginationPageToken, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetManagerAnalytics — агрегированная аналитика работы менеджеров: участие в сделках по этапам, исходы Won/Lost при участии, задачи выполнено/просрочено. Только для ролей hos/admin (проверка в service-слое).
     * @param {string} [periodFrom] Период: пересечение интервала ответственности менеджера с [period_from, period_to). Обе границы опциональны (нет границы &#x3D; без ограничения).
     * @param {string} [periodTo]
     * @param {Array<string>} [managerIds] Фильтр по менеджерам; пусто &#x3D; все менеджеры.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceGetManagerAnalytics(
      periodFrom?: string,
      periodTo?: string,
      managerIds?: Array<string>,
      options?: any,
    ): AxiosPromise<V1GetManagerAnalyticsResponse> {
      return localVarFp
        .dealsServiceGetManagerAnalytics(periodFrom, periodTo, managerIds, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} clientId
     * @param {number} [paginationPageSize] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [paginationPageToken] Курсор из next_page_token предыдущего ответа; \&quot;\&quot; &#x3D; первая страница.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceListClientDeals(
      clientId: string,
      paginationPageSize?: number,
      paginationPageToken?: string,
      options?: any,
    ): AxiosPromise<V1ListDealsResponse> {
      return localVarFp
        .dealsServiceListClientDeals(clientId, paginationPageSize, paginationPageToken, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary -------------------- Comments (DEV-195) -------------------- Список комментариев менеджера по сделке. Возвращаются в хронологическом порядке (от старого к новому). ФИО автора резолвится фронтом по локальному списку менеджеров — backend отдаёт только manager_id.
     * @param {string} dealId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceListDealComments(
      dealId: string,
      options?: any,
    ): AxiosPromise<V1ListDealCommentsResponse> {
      return localVarFp
        .dealsServiceListDealComments(dealId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} dealId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceListDealFiles(
      dealId: string,
      options?: any,
    ): AxiosPromise<V1ListDealFilesResponse> {
      return localVarFp
        .dealsServiceListDealFiles(dealId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary -------------------- Deal Managers (DEV-197) -------------------- ListDealManagers — история ответственных менеджеров сделки с диапазонами этапов. Только для ролей hos/admin (проверка в service-слое) — данные используются для KPI/вознаграждения.
     * @param {string} dealId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceListDealManagers(
      dealId: string,
      options?: any,
    ): AxiosPromise<V1ListDealManagersResponse> {
      return localVarFp
        .dealsServiceListDealManagers(dealId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {number} [paginationPageSize] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {string} [paginationPageToken] Курсор из next_page_token предыдущего ответа; \&quot;\&quot; &#x3D; первая страница.
     * @param {Array<DealsServiceListDealsStageTypesEnum>} [stageTypes] DEV-206. Серверные фильтры — раньше канбан брал топ-50 по created_at DESC и фильтровал на клиенте, из-за чего «хвостовые» сделки терялись.   - STAGE_TYPE_INVALID: Невалидный тип  - STAGE_TYPE_UNSORTED: Не разобрано (скрытый этап для РОП)  - STAGE_TYPE_NEW_LEAD: Новый ЛИД  - STAGE_TYPE_NO_CONTACT: Не вышел на связь  - STAGE_TYPE_CONTACTED: Вышел на связь  - STAGE_TYPE_QUALIFIED: Квалифицирован  - STAGE_TYPE_OFFER_SENT: Предложение отправлено  - STAGE_TYPE_PRESENTATION_SCHEDULED: Презентация назначена  - STAGE_TYPE_PRESENTATION_DONE: Презентация проектов проведена  - STAGE_TYPE_FOLLOWUP_PRESENTATION_DONE: Повторная встреча / презентация проведена  - STAGE_TYPE_BOOKED: Объект забронирован  - STAGE_TYPE_DEPOSIT_PAID: Депозит внесен  - STAGE_TYPE_CONTRACT_SIGNED: Договор бронирования подписан / внесен DP  - STAGE_TYPE_CONTRACT_HANDED_OVER: Оригинал договора передан застройщику  - STAGE_TYPE_COMMISSION_PAID: Комиссионные выплачены  - STAGE_TYPE_LOST: Закрыто и не реализовано
     * @param {DealsServiceListDealsStatusEnum} [status]  - DEAL_STATUS_INVALID: Невалидный статус  - DEAL_STATUS_ACTIVE: Сделка активна  - DEAL_STATUS_WON: Сделка успешно закрыта  - DEAL_STATUS_LOST: Сделка закрыта без положительного результата  - DEAL_STATUS_CANCELED: Сделка отменена
     * @param {string} [responsibleManagerId]
     * @param {string} [clientId]
     * @param {string} [search] FTS по title + body deal_comments (&#x60;to_tsvector&#x60; / &#x60;plainto_tsquery&#x60;). DEV-195: после выноса комментариев в 1:N поиск идёт по title сделки и EXISTS-подзапросу по deal_comments.body. Поиск по имени клиента/менеджера тут НЕ делается — это другой сервис; фронт сначала резолвит клиента в client_id.
     * @param {string} [createdAfter]
     * @param {string} [createdBefore]
     * @param {string} [agentId] DEV-512. Фильтр по агенту (deals.agent_id, снапшот DEV-474) — для вкладки «Сделки» в карточке агента. \&quot;\&quot; игнорируется.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceListDeals(
      paginationPageSize?: number,
      paginationPageToken?: string,
      stageTypes?: Array<DealsServiceListDealsStageTypesEnum>,
      status?: DealsServiceListDealsStatusEnum,
      responsibleManagerId?: string,
      clientId?: string,
      search?: string,
      createdAfter?: string,
      createdBefore?: string,
      agentId?: string,
      options?: any,
    ): AxiosPromise<V1ListDealsResponse> {
      return localVarFp
        .dealsServiceListDeals(
          paginationPageSize,
          paginationPageToken,
          stageTypes,
          status,
          responsibleManagerId,
          clientId,
          search,
          createdAfter,
          createdBefore,
          agentId,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary DEV-196. История редактирований задач сделки (кто и когда правил описание/сроки). Возвращается от новых к старым. ФИО редактора резолвит фронт по списку менеджеров.
     * @param {string} dealId
     * @param {string} [taskId] Фильтр по задаче (опционально)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceListTaskEdits(
      dealId: string,
      taskId?: string,
      options?: any,
    ): AxiosPromise<V1ListTaskEditsResponse> {
      return localVarFp
        .dealsServiceListTaskEdits(dealId, taskId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} dealId
     * @param {DealsServiceListTasksStageTypeEnum} [stageType] Фильтр по этапу (опционально)   - STAGE_TYPE_INVALID: Невалидный тип  - STAGE_TYPE_UNSORTED: Не разобрано (скрытый этап для РОП)  - STAGE_TYPE_NEW_LEAD: Новый ЛИД  - STAGE_TYPE_NO_CONTACT: Не вышел на связь  - STAGE_TYPE_CONTACTED: Вышел на связь  - STAGE_TYPE_QUALIFIED: Квалифицирован  - STAGE_TYPE_OFFER_SENT: Предложение отправлено  - STAGE_TYPE_PRESENTATION_SCHEDULED: Презентация назначена  - STAGE_TYPE_PRESENTATION_DONE: Презентация проектов проведена  - STAGE_TYPE_FOLLOWUP_PRESENTATION_DONE: Повторная встреча / презентация проведена  - STAGE_TYPE_BOOKED: Объект забронирован  - STAGE_TYPE_DEPOSIT_PAID: Депозит внесен  - STAGE_TYPE_CONTRACT_SIGNED: Договор бронирования подписан / внесен DP  - STAGE_TYPE_CONTRACT_HANDED_OVER: Оригинал договора передан застройщику  - STAGE_TYPE_COMMISSION_PAID: Комиссионные выплачены  - STAGE_TYPE_LOST: Закрыто и не реализовано
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceListTasks(
      dealId: string,
      stageType?: DealsServiceListTasksStageTypeEnum,
      options?: any,
    ): AxiosPromise<V1ListTasksResponse> {
      return localVarFp
        .dealsServiceListTasks(dealId, stageType, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary RemoveDealSupportManager — снять сопровождающего менеджера со сделки (soft: removed_at/removed_by). Гейт тот же, что у Add. Снятие неактивного — идемпотентный no-op. Возвращает актуальный список активных сопровождающих.
     * @param {string} dealId
     * @param {string} managerId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceRemoveDealSupportManager(
      dealId: string,
      managerId: string,
      options?: any,
    ): AxiosPromise<V1DealSupportManagersResponse> {
      return localVarFp
        .dealsServiceRemoveDealSupportManager(dealId, managerId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id UUID сделки - обязательно
     * @param {DealsServiceUpdateDealBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceUpdateDeal(
      id: string,
      body: DealsServiceUpdateDealBody,
      options?: any,
    ): AxiosPromise<V1UpdateDealResponse> {
      return localVarFp
        .dealsServiceUpdateDeal(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} dealId
     * @param {string} id
     * @param {DealsServiceUpdateDealCommentBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceUpdateDealComment(
      dealId: string,
      id: string,
      body: DealsServiceUpdateDealCommentBody,
      options?: any,
    ): AxiosPromise<V1UpdateDealCommentResponse> {
      return localVarFp
        .dealsServiceUpdateDealComment(dealId, id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} dealId
     * @param {string} fileId
     * @param {DealsServiceUpdateDealFileBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceUpdateDealFile(
      dealId: string,
      fileId: string,
      body: DealsServiceUpdateDealFileBody,
      options?: any,
    ): AxiosPromise<V1UpdateDealFileResponse> {
      return localVarFp
        .dealsServiceUpdateDealFile(dealId, fileId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} dealId
     * @param {string} id
     * @param {DealsServiceUpdateTaskBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    dealsServiceUpdateTask(
      dealId: string,
      id: string,
      body: DealsServiceUpdateTaskBody,
      options?: any,
    ): AxiosPromise<V1UpdateTaskResponse> {
      return localVarFp
        .dealsServiceUpdateTask(dealId, id, body, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * DealsServiceApi - object-oriented interface
 * @export
 * @class DealsServiceApi
 * @extends {BaseAPI}
 */
export class DealsServiceApi extends BaseAPI {
  /**
   *
   * @summary -------------------- Files --------------------
   * @param {string} dealId
   * @param {DealsServiceAddDealFileBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceAddDealFile(
    dealId: string,
    body: DealsServiceAddDealFileBody,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceAddDealFile(dealId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary -------------------- Deal Support Managers (DEV-699) -------------------- AddDealSupportManager — подключить сопровождающего менеджера к сделке. Доступ: ответственный по сделке / hos / admin (гейт в service-слое). Подключаемый пользователь обязан иметь роль support_manager (проверка через auth, fail-close). Сопровождающий ≠ ответственный; сделка должна быть активной; повторное подключение активного сопровождающего — идемпотентный no-op. Возвращает актуальный список АКТИВНЫХ сопровождающих после операции.
   * @param {string} dealId
   * @param {DealsServiceAddDealSupportManagerBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceAddDealSupportManager(
    dealId: string,
    body: DealsServiceAddDealSupportManagerBody,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceAddDealSupportManager(dealId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary -------------------- Stages (упрощенные) --------------------
   * @param {string} dealId
   * @param {DealsServiceChangeStageBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceChangeStage(
    dealId: string,
    body: DealsServiceChangeStageBody,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceChangeStage(dealId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary CheckStageTransition — DEV-527. Precheck перехода на этап (без мутаций): блокирующие обязательные задачи + мягкий WIP-лимит. Гейт = deals:read.
   * @param {string} dealId
   * @param {DealsServiceCheckStageTransitionBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceCheckStageTransition(
    dealId: string,
    body: DealsServiceCheckStageTransitionBody,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceCheckStageTransition(dealId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary -------------------- Deals --------------------
   * @param {V1CreateDealRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceCreateDeal(body: V1CreateDealRequest, options?: RawAxiosRequestConfig) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceCreateDeal(body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} dealId
   * @param {DealsServiceCreateDealCommentBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceCreateDealComment(
    dealId: string,
    body: DealsServiceCreateDealCommentBody,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceCreateDealComment(dealId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary -------------------- Tasks --------------------
   * @param {string} dealId
   * @param {DealsServiceCreateTaskBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceCreateTask(
    dealId: string,
    body: DealsServiceCreateTaskBody,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceCreateTask(dealId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id UUID сделки - обязательно
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceDeleteDeal(id: string, options?: RawAxiosRequestConfig) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceDeleteDeal(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} dealId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceDeleteDealComment(
    dealId: string,
    id: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceDeleteDealComment(dealId, id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} dealId
   * @param {string} fileId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceDeleteDealFile(
    dealId: string,
    fileId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceDeleteDealFile(dealId, fileId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} dealId
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceDeleteTask(dealId: string, id: string, options?: RawAxiosRequestConfig) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceDeleteTask(dealId, id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} [period] Период для расчёта прироста (опционально, по умолчанию - week)  \&quot;day\&quot;, \&quot;week\&quot;, \&quot;month\&quot;
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceGetDashboardMetrics(period?: string, options?: RawAxiosRequestConfig) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceGetDashboardMetrics(period, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id UUID сделки - обязательно
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceGetDeal(id: string, options?: RawAxiosRequestConfig) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceGetDeal(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary -------------------- Action Logs --------------------
   * @param {string} dealId UUID сделки - обязательно
   * @param {number} [paginationPageSize] Размер страницы; 0 &#x3D; дефолт сервиса.
   * @param {string} [paginationPageToken] Курсор из next_page_token предыдущего ответа; \&quot;\&quot; &#x3D; первая страница.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceGetDealActionLogs(
    dealId: string,
    paginationPageSize?: number,
    paginationPageToken?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceGetDealActionLogs(dealId, paginationPageSize, paginationPageToken, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetManagerAnalytics — агрегированная аналитика работы менеджеров: участие в сделках по этапам, исходы Won/Lost при участии, задачи выполнено/просрочено. Только для ролей hos/admin (проверка в service-слое).
   * @param {string} [periodFrom] Период: пересечение интервала ответственности менеджера с [period_from, period_to). Обе границы опциональны (нет границы &#x3D; без ограничения).
   * @param {string} [periodTo]
   * @param {Array<string>} [managerIds] Фильтр по менеджерам; пусто &#x3D; все менеджеры.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceGetManagerAnalytics(
    periodFrom?: string,
    periodTo?: string,
    managerIds?: Array<string>,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceGetManagerAnalytics(periodFrom, periodTo, managerIds, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} clientId
   * @param {number} [paginationPageSize] Размер страницы; 0 &#x3D; дефолт сервиса.
   * @param {string} [paginationPageToken] Курсор из next_page_token предыдущего ответа; \&quot;\&quot; &#x3D; первая страница.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceListClientDeals(
    clientId: string,
    paginationPageSize?: number,
    paginationPageToken?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceListClientDeals(clientId, paginationPageSize, paginationPageToken, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary -------------------- Comments (DEV-195) -------------------- Список комментариев менеджера по сделке. Возвращаются в хронологическом порядке (от старого к новому). ФИО автора резолвится фронтом по локальному списку менеджеров — backend отдаёт только manager_id.
   * @param {string} dealId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceListDealComments(dealId: string, options?: RawAxiosRequestConfig) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceListDealComments(dealId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} dealId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceListDealFiles(dealId: string, options?: RawAxiosRequestConfig) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceListDealFiles(dealId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary -------------------- Deal Managers (DEV-197) -------------------- ListDealManagers — история ответственных менеджеров сделки с диапазонами этапов. Только для ролей hos/admin (проверка в service-слое) — данные используются для KPI/вознаграждения.
   * @param {string} dealId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceListDealManagers(dealId: string, options?: RawAxiosRequestConfig) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceListDealManagers(dealId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {number} [paginationPageSize] Размер страницы; 0 &#x3D; дефолт сервиса.
   * @param {string} [paginationPageToken] Курсор из next_page_token предыдущего ответа; \&quot;\&quot; &#x3D; первая страница.
   * @param {Array<DealsServiceListDealsStageTypesEnum>} [stageTypes] DEV-206. Серверные фильтры — раньше канбан брал топ-50 по created_at DESC и фильтровал на клиенте, из-за чего «хвостовые» сделки терялись.   - STAGE_TYPE_INVALID: Невалидный тип  - STAGE_TYPE_UNSORTED: Не разобрано (скрытый этап для РОП)  - STAGE_TYPE_NEW_LEAD: Новый ЛИД  - STAGE_TYPE_NO_CONTACT: Не вышел на связь  - STAGE_TYPE_CONTACTED: Вышел на связь  - STAGE_TYPE_QUALIFIED: Квалифицирован  - STAGE_TYPE_OFFER_SENT: Предложение отправлено  - STAGE_TYPE_PRESENTATION_SCHEDULED: Презентация назначена  - STAGE_TYPE_PRESENTATION_DONE: Презентация проектов проведена  - STAGE_TYPE_FOLLOWUP_PRESENTATION_DONE: Повторная встреча / презентация проведена  - STAGE_TYPE_BOOKED: Объект забронирован  - STAGE_TYPE_DEPOSIT_PAID: Депозит внесен  - STAGE_TYPE_CONTRACT_SIGNED: Договор бронирования подписан / внесен DP  - STAGE_TYPE_CONTRACT_HANDED_OVER: Оригинал договора передан застройщику  - STAGE_TYPE_COMMISSION_PAID: Комиссионные выплачены  - STAGE_TYPE_LOST: Закрыто и не реализовано
   * @param {DealsServiceListDealsStatusEnum} [status]  - DEAL_STATUS_INVALID: Невалидный статус  - DEAL_STATUS_ACTIVE: Сделка активна  - DEAL_STATUS_WON: Сделка успешно закрыта  - DEAL_STATUS_LOST: Сделка закрыта без положительного результата  - DEAL_STATUS_CANCELED: Сделка отменена
   * @param {string} [responsibleManagerId]
   * @param {string} [clientId]
   * @param {string} [search] FTS по title + body deal_comments (&#x60;to_tsvector&#x60; / &#x60;plainto_tsquery&#x60;). DEV-195: после выноса комментариев в 1:N поиск идёт по title сделки и EXISTS-подзапросу по deal_comments.body. Поиск по имени клиента/менеджера тут НЕ делается — это другой сервис; фронт сначала резолвит клиента в client_id.
   * @param {string} [createdAfter]
   * @param {string} [createdBefore]
   * @param {string} [agentId] DEV-512. Фильтр по агенту (deals.agent_id, снапшот DEV-474) — для вкладки «Сделки» в карточке агента. \&quot;\&quot; игнорируется.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceListDeals(
    paginationPageSize?: number,
    paginationPageToken?: string,
    stageTypes?: Array<DealsServiceListDealsStageTypesEnum>,
    status?: DealsServiceListDealsStatusEnum,
    responsibleManagerId?: string,
    clientId?: string,
    search?: string,
    createdAfter?: string,
    createdBefore?: string,
    agentId?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceListDeals(
        paginationPageSize,
        paginationPageToken,
        stageTypes,
        status,
        responsibleManagerId,
        clientId,
        search,
        createdAfter,
        createdBefore,
        agentId,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary DEV-196. История редактирований задач сделки (кто и когда правил описание/сроки). Возвращается от новых к старым. ФИО редактора резолвит фронт по списку менеджеров.
   * @param {string} dealId
   * @param {string} [taskId] Фильтр по задаче (опционально)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceListTaskEdits(
    dealId: string,
    taskId?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceListTaskEdits(dealId, taskId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} dealId
   * @param {DealsServiceListTasksStageTypeEnum} [stageType] Фильтр по этапу (опционально)   - STAGE_TYPE_INVALID: Невалидный тип  - STAGE_TYPE_UNSORTED: Не разобрано (скрытый этап для РОП)  - STAGE_TYPE_NEW_LEAD: Новый ЛИД  - STAGE_TYPE_NO_CONTACT: Не вышел на связь  - STAGE_TYPE_CONTACTED: Вышел на связь  - STAGE_TYPE_QUALIFIED: Квалифицирован  - STAGE_TYPE_OFFER_SENT: Предложение отправлено  - STAGE_TYPE_PRESENTATION_SCHEDULED: Презентация назначена  - STAGE_TYPE_PRESENTATION_DONE: Презентация проектов проведена  - STAGE_TYPE_FOLLOWUP_PRESENTATION_DONE: Повторная встреча / презентация проведена  - STAGE_TYPE_BOOKED: Объект забронирован  - STAGE_TYPE_DEPOSIT_PAID: Депозит внесен  - STAGE_TYPE_CONTRACT_SIGNED: Договор бронирования подписан / внесен DP  - STAGE_TYPE_CONTRACT_HANDED_OVER: Оригинал договора передан застройщику  - STAGE_TYPE_COMMISSION_PAID: Комиссионные выплачены  - STAGE_TYPE_LOST: Закрыто и не реализовано
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceListTasks(
    dealId: string,
    stageType?: DealsServiceListTasksStageTypeEnum,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceListTasks(dealId, stageType, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary RemoveDealSupportManager — снять сопровождающего менеджера со сделки (soft: removed_at/removed_by). Гейт тот же, что у Add. Снятие неактивного — идемпотентный no-op. Возвращает актуальный список активных сопровождающих.
   * @param {string} dealId
   * @param {string} managerId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceRemoveDealSupportManager(
    dealId: string,
    managerId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceRemoveDealSupportManager(dealId, managerId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id UUID сделки - обязательно
   * @param {DealsServiceUpdateDealBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceUpdateDeal(
    id: string,
    body: DealsServiceUpdateDealBody,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceUpdateDeal(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} dealId
   * @param {string} id
   * @param {DealsServiceUpdateDealCommentBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceUpdateDealComment(
    dealId: string,
    id: string,
    body: DealsServiceUpdateDealCommentBody,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceUpdateDealComment(dealId, id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} dealId
   * @param {string} fileId
   * @param {DealsServiceUpdateDealFileBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceUpdateDealFile(
    dealId: string,
    fileId: string,
    body: DealsServiceUpdateDealFileBody,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceUpdateDealFile(dealId, fileId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} dealId
   * @param {string} id
   * @param {DealsServiceUpdateTaskBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DealsServiceApi
   */
  public dealsServiceUpdateTask(
    dealId: string,
    id: string,
    body: DealsServiceUpdateTaskBody,
    options?: RawAxiosRequestConfig,
  ) {
    return DealsServiceApiFp(this.configuration)
      .dealsServiceUpdateTask(dealId, id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * @export
 */
export const DealsServiceListDealsStageTypesEnum = {
  Invalid: 'STAGE_TYPE_INVALID',
  Unsorted: 'STAGE_TYPE_UNSORTED',
  NewLead: 'STAGE_TYPE_NEW_LEAD',
  NoContact: 'STAGE_TYPE_NO_CONTACT',
  Contacted: 'STAGE_TYPE_CONTACTED',
  Qualified: 'STAGE_TYPE_QUALIFIED',
  OfferSent: 'STAGE_TYPE_OFFER_SENT',
  PresentationScheduled: 'STAGE_TYPE_PRESENTATION_SCHEDULED',
  PresentationDone: 'STAGE_TYPE_PRESENTATION_DONE',
  FollowupPresentationDone: 'STAGE_TYPE_FOLLOWUP_PRESENTATION_DONE',
  Booked: 'STAGE_TYPE_BOOKED',
  DepositPaid: 'STAGE_TYPE_DEPOSIT_PAID',
  ContractSigned: 'STAGE_TYPE_CONTRACT_SIGNED',
  ContractHandedOver: 'STAGE_TYPE_CONTRACT_HANDED_OVER',
  CommissionPaid: 'STAGE_TYPE_COMMISSION_PAID',
  Lost: 'STAGE_TYPE_LOST',
} as const
export type DealsServiceListDealsStageTypesEnum =
  (typeof DealsServiceListDealsStageTypesEnum)[keyof typeof DealsServiceListDealsStageTypesEnum]
/**
 * @export
 */
export const DealsServiceListDealsStatusEnum = {
  Invalid: 'DEAL_STATUS_INVALID',
  Active: 'DEAL_STATUS_ACTIVE',
  Won: 'DEAL_STATUS_WON',
  Lost: 'DEAL_STATUS_LOST',
  Canceled: 'DEAL_STATUS_CANCELED',
} as const
export type DealsServiceListDealsStatusEnum =
  (typeof DealsServiceListDealsStatusEnum)[keyof typeof DealsServiceListDealsStatusEnum]
/**
 * @export
 */
export const DealsServiceListTasksStageTypeEnum = {
  Invalid: 'STAGE_TYPE_INVALID',
  Unsorted: 'STAGE_TYPE_UNSORTED',
  NewLead: 'STAGE_TYPE_NEW_LEAD',
  NoContact: 'STAGE_TYPE_NO_CONTACT',
  Contacted: 'STAGE_TYPE_CONTACTED',
  Qualified: 'STAGE_TYPE_QUALIFIED',
  OfferSent: 'STAGE_TYPE_OFFER_SENT',
  PresentationScheduled: 'STAGE_TYPE_PRESENTATION_SCHEDULED',
  PresentationDone: 'STAGE_TYPE_PRESENTATION_DONE',
  FollowupPresentationDone: 'STAGE_TYPE_FOLLOWUP_PRESENTATION_DONE',
  Booked: 'STAGE_TYPE_BOOKED',
  DepositPaid: 'STAGE_TYPE_DEPOSIT_PAID',
  ContractSigned: 'STAGE_TYPE_CONTRACT_SIGNED',
  ContractHandedOver: 'STAGE_TYPE_CONTRACT_HANDED_OVER',
  CommissionPaid: 'STAGE_TYPE_COMMISSION_PAID',
  Lost: 'STAGE_TYPE_LOST',
} as const
export type DealsServiceListTasksStageTypeEnum =
  (typeof DealsServiceListTasksStageTypeEnum)[keyof typeof DealsServiceListTasksStageTypeEnum]
